import { Pipe, PipeTransform } from '@angular/core';
import { CampaignDefaultView } from '../../core/enum/campaign-default-view.enum';

/**
 * FRC-1035: where a discovery card (campaign listing, homepage, partner pages) sends someone who
 * clicks it: `campaign.slug | campaignCardLink: campaign.defaultView`. The backend has already
 * resolved `defaultView`; this only turns that answer into a route, so every card links the same
 * way. A missing `defaultView` opens the Campaign Page.
 *
 * Pure and keyed on the two primitives, so the link array is reused across change detection and
 * still follows a campaign that is updated in place.
 *
 * Post-commitment surfaces (my investments, wallet, updates feed, emails...) must not use this:
 * they always open the Campaign Page.
 */
@Pipe({ name: 'campaignCardLink' })
export class CampaignCardLinkPipe implements PipeTransform {
  transform(slug: string, defaultView?: CampaignDefaultView): string[] {
    return defaultView === CampaignDefaultView.CampaignSummary
      ? ['/campaign-summary', slug]
      : ['/equity', slug];
  }
}
